import './AccessDenied.sass';

import React from 'react';

import { useTranslator } from '$hooks';
import { Button } from '$uikit';
import { FEED } from '$shared/constants/pages';
import { Link } from 'react-router5';

export function AccessDenied() {
  const t = useTranslator();

  return (
    <div className="AccessDenied">
      <div className="AccessDenied__title">{t('access_denied_title')}</div>
      <div className="AccessDenied__caption">{t('access_denied_caption')}</div>
      <div className="AccessDenied__button">
        <Link routeName={FEED}>
          <Button>{t('go_to_home')}</Button>
        </Link>
      </div>
    </div>
  );
}
